module.exports = __webpack_public_path__ + "img/bg_left_img.13fdce02.png";